import Vue from 'vue';
import Router from 'vue-router';
import store from './store/store';
import eventBus from './helpers/event-bus';
import Clients from './views/Clients.vue';
import Client from './views/Client.vue';
import Users from './views/Users.vue';
import User from './views/User.vue';
import FilesSearch from './views/FilesSearch.vue';
import Files from './views/Files.vue';
import Login from './views/Login.vue';
import RecivePassword from './views/RecivePassword.vue';
import ResetPassword from './views/ResetPassword.vue';
import Dashboard from './views/Dashboard.vue';
import Profile from './views/Profile.vue';
import SetPassword from './views/SetPassword.vue';
import History from './views/History.vue';
import Faq from './views/Faq.vue';
import LandingPage from './views/LandingPage.vue';
import PageNotFound from './views/PageNotFound.vue';
import PrivacyPolicy from './views/PrivacyPolicy.vue';
import Regulations from './views/Regulations.vue';
import Donation from './views/Donation.vue';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'LandingPage',
      component: LandingPage,
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
    },
    {
      path: '/polityka-prywatnosci',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy,
    },
    {
      path: '/regulamin',
      name: 'Regulations',
      component: Regulations,
    },
    {
      path: '/dofinansowanie',
      name: 'Donation',
      component: Donation,
    },
    {
      path: '/klienci/:page',
      name: 'clients',
      component: Clients,
    },
    {
      path: '/klient/:id',
      name: 'client',
      component: Client,
    },
    {
      path: '/uzytkownicy/:page',
      name: 'users',
      component: Users,
    },
    {
      path: '/pliki/',
      name: 'files',
      component: Files,
    },
    {
      path: '/pliki/klient/:clientId/katalog/:id',
      name: 'folder',
      component: Files,
    },
    {
      path: '/pliki/klient/:clientId/szukaj',
      name: 'searchFiles',
      component: FilesSearch,
    },
    {
      path: '/uzytkownik/:id',
      name: 'user',
      component: User,
    },
    {
      path: '/login/:id/:token',
      name: 'login-unblock',
      component: Login,
    },
    {
      path: '/login/',
      name: 'login',
      component: Login,
    },
    {
      path: '/profil',
      name: 'profile',
      component: Profile,
    },
    {
      path: '/ustaw-haslo',
      name: 'setPassword',
      component: SetPassword,
    },
    {
      path: '/przypomnij-haslo',
      name: 'recive-password',
      component: RecivePassword,
    },
    {
      path: '/resetuj-haslo/:token',
      name: 'reset-password',
      component: ResetPassword,
    },
    {
      path: '/historia/:page',
      name: 'history',
      component: History,
    },
    {
      path: '/faq',
      name: 'faq',
      component: Faq,
    },
    {
      path: '*',
      name: 'PageNotFound',
      component: PageNotFound,
    },
  ],
});

router.beforeEach((to, from, next) => {
  // kasowanie bledow
  // store.dispatch('app/clearErrors');

  // podczas wysylania plikow nie mozemy zmienic strony
  if (store.getters['files/fileUploadInProgress']) {
    store.dispatch('app/setSnackBar', 'Poczekaj na zakończenie wysyłania plików', { root: true });
    return;
  }
  // jak nie ma uploadu to upewniamy sie ze okno wysylania plikow jest ukryte
  if (from.name === 'folder') {
    eventBus.$emit('Files/FilesUpload/hide');
  }
  next();
});

export default router;
